<template>
    <div v-if="doc">
        <template v-for="answer in answered">
            <span class="text-sm ml-8 mr-2" :key="`${answer.key}-label`">{{ answer.title }}</span>
            <span class="mr-2" :key="`${answer.key}-value`">{{ answer.value }}</span>
        </template>
    </div>
</template>

<script>
import { answers } from "@/utils/surveyFields";

export default {
    name: "TilesResultsBasic",
    props: {
        doc: {
            type: Object,
            default: () => { },
        },
        // step 1 field definitions from the project content file
        fields: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        // every answer on the response, declared in the content file or not
        answered() {
            return answers(this.doc, this.fields);
        },
    },
};
</script>
